import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
  GET_VMS_AZURE, GET_VMS_AZURE_SUCCESS, GET_VMS_AZURE_ERROR
} from './constant';

import { getAzureVmsApi } from './api';

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureVmsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureVmsApi, params, provider);
    yield put({ type: GET_VMS_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_VMS_AZURE_ERROR, error });
  }
}


/**
 * Get Login Saga
 */
export function* manageAzureVmsSaga() {
  yield takeLatest(GET_VMS_AZURE, getAzureVmsList);

}
